import { ETrackingEventsName } from '../../models/Tracking.interfaces';
import apiRequestTemplate from './json-interfaces/navigationTracking-apiRequest.json';
import screenViewTemplate from './json-interfaces/navigationTracking-screenView.json';
import userInteractionTemplate from './json-interfaces/navigationTracking-userInteraction.json';

function deepClone<T>(obj: T): T {
    return JSON.parse(JSON.stringify(obj));
}

function getTrackingJSON(type: ETrackingEventsName, data: any) {
    try {
        // clone templates to avoid mutating the imported singletons
        let jsonRequest_apiRequest = deepClone(apiRequestTemplate);
        let jsonRequest_screenView = deepClone(screenViewTemplate);
        let jsonRequest_userInteraction = deepClone(userInteractionTemplate);
        let jsonResults: any = {};
        switch (type) {
            case 'api-request': {
                jsonRequest_apiRequest.data.data = data;
                jsonResults = jsonRequest_apiRequest;
                break;
            }
            case 'screen-view': {
                jsonRequest_screenView.data.data = data;
                jsonResults = jsonRequest_screenView;
                break;
            }
            case 'user-interaction': {
                jsonRequest_userInteraction.data.data = data;
                jsonResults = jsonRequest_userInteraction;
                break;
            }
            default:
                return '';
        }
        return JSON.stringify(jsonResults);
    } catch (error) {
        console.error(error);
    }
}

export default getTrackingJSON;
